import {Line} from '@visx/shape';
import React from 'react';

export const STROKE_WIDTH = 3;

export interface CrossProps {
  color: string;
  radius: number;
  x: number;
  y: number;
}

export default function Cross({color, radius, x, y}: CrossProps): JSX.Element {
  return (
    <>
      <Line
        from={{
          x: x - radius,
          y: y - radius,
        }}
        to={{
          x: x + radius,
          y: y + radius,
        }}
        stroke={color}
        strokeWidth={STROKE_WIDTH}
      />
      <Line
        from={{
          x: x + radius,
          y: y - radius,
        }}
        to={{
          x: x - radius,
          y: y + radius,
        }}
        stroke={color}
        strokeWidth={STROKE_WIDTH}
      />
    </>
  );
}
